const types ={
    login: 'login',
    logout: 'logout',
    contratar: 'contratar',
    anular: 'anular'
}

export default types